module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-04@2x.4ca135b.jpg";